export const companyManagementUserId = "0";

export const isCompanyManagement = userId=>{
    if(!userId) return false;
    return companyManagementUserId == userId
}